import { useState, useEffect } from 'react';
import React from 'react'
import { Row, Col, Card, CardBody, CardHeader, Modal, ModalHeader, ModalBody, ModalFooter, Button, Collapse, Table } from 'reactstrap';
import { FaTrash, FaChevronUp, FaChevronDown } from 'react-icons/fa';
import axios from 'axios';
import toast, { Toaster } from 'react-hot-toast'; import { apiGet, apiPost } from "../Utilities/Hooks/apiWrapper";

const getBase64 = (file) => {
    return new Promise(resolve => {
        let baseURL = "";
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
            baseURL = reader.result;
            resolve(baseURL);
        };
    });
};

const PhotosWinterGrazingWithoutId = ({ refId, uploadType, header, disabledMode, imageUploadList, setImageUploadList }) => {
    const roleName = localStorage.getItem("roleName");
    const isAddEditItem = localStorage.getItem("isAddEditItem");
    const [loading, setLoading] = useState(true);
    const [userId, setUserId] = useState(localStorage.getItem("loggedInUserId"));
    
    const [showDeleteItemPopup, setShowDeleteItemPopup] = useState(false);
    const [showUploadingPopup, setShowUploadingPopup] = useState(false);
    const [deleteItemId, setDeleteItemId] = useState(0);
    const [imageViewPopup, setImageViewPopup] = useState({ showImageViewPopup: false, imageName: '', imageUrl: '' });
    const [isOpen, setIsOpen] = useState(false);
    const [isIconUp, setIsIconUp] = useState(false);
    const [imageIndex, setImageIndex] = useState(0);

    let inputFile = '';

    const OnPageload = async (e) => {
        refId = refId == undefined ? 0 : refId;
        if (refId != 0) {
            try {
                const response = await apiGet('/api/upload/GetUploadedImages/', { params: { Id: refId, UploadType: uploadType } });
                if (response.data.status) {
                    setImageUploadList(response.data.content);
                }
            } catch (err) {
                console.log(err);
            }
        }
        setLoading(false);
    }

    const toggle = () => {
        setIsOpen(!isOpen)
        setIsIconUp(!isIconUp)
    };

    useEffect(() => {
        setLoading(true);
        OnPageload();
    }, [])

    const openDeleteItemPopup = async (item, index) => {
        setShowDeleteItemPopup(true);
        setDeleteItemId(item.id);
        setImageIndex(index);
    }

    const handleImageChange = async (e) => {
        e.preventDefault();
        setShowUploadingPopup(true);
        let reader = new FileReader();
        let file = e.target.files[0];
        if (file.type != 'image/png' && file.type != 'image/jpeg' && file.type != 'image/jpg') {
            toast.error("Image uploads must be in .jpg format and less than 5mb in size. Please adjust the file you are trying to upload and try again.", { duration: 3000, style: { border: '1px solid #f76054', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#E82300', secondary: '#FFFAEE', } });
            return false;
        }
        else if ((file.size / (1024 * 1024)) > 5) {
            toast.error("Image uploads must be in .jpg format and less than 5mb in size. Please adjust the file you are trying to upload and try again.", { duration: 3000, style: { border: '1px solid #f76054', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#E82300', secondary: '#FFFAEE', } });
            return false;
        }
        getBase64(file)
            .then(result => {
                let form = {
                    FileName: file.name.replace(/\.[^/.]+$/, ""),
                    Type: uploadType,
                    Base64Image: result,
                    RefId: refId,
                    userId: userId
                }
                if (refId == 0) {
                    const response = apiPost(
                        '/api/upload/UploadImageWithoutId/', JSON.stringify(form),
                        {
                            headers: { 'Content-Type': 'application/json' },
                            withCredentials: true
                        }).then(res => {
                            if (res.data != null) {
                                if (res.data.status) {
                                    setTimeout(() => {
                                        //setImageUploadList(res.data.content);
                                        toast.success("Image Uploaded!", { duration: 3000, style: { border: '1px solid #B6D137', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#B6D137', secondary: '#FFFAEE', } });
                                        const item = {
                                            id: res.data.content.Id, referenceId: res.data.content.ReferenceId, uploadType: res.data.content.UploadType, imageDetail: res.data.content.ImageDetail,
                                            imageName: res.data.content.ImageName, imagePhysicalName: res.data.content.ImagePhysicalName, imagePath: res.data.content.ImagePath,
                                            imageRelativePath: res.data.content.ImageRelativePath, createdOnText: res.data.content.CreatedOnText,createdOn: res.data.content.Id
                                        };
                                        setImageUploadList([...imageUploadList, item]);
                                        setShowUploadingPopup(false);
                                    }, 1000);
                                }
                            }
                        });
                }
                else {
                    const response = apiPost(
                        '/api/upload/UploadImage/', JSON.stringify(form),
                        {
                            headers: { 'Content-Type': 'application/json' },
                            withCredentials: true
                        }).then(res => {
                            if (res.data != null) {
                                if (res.data.status) {
                                    setTimeout(() => {
                                        toast.success("Images Saved!", { duration: 3000, style: { border: '1px solid #B6D137', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#B6D137', secondary: '#FFFAEE', } });
                                        setImageUploadList(res.data.content);
                                        setShowUploadingPopup(false);
                                    }, 1000);
                                }
                            }
                        });
                }
            })
            .catch(err => {
                console.log(err);
            });

        reader.onloadend = () => {
            e.target.value = null;
        }

        reader.readAsDataURL(file)
    }

    const handleBtnUploadClick = async (e) => {
        e.preventDefault();
        inputFile.click();
        return false;
    }

    const closeDeleteItemPopup = async () => {
        setShowDeleteItemPopup(false);
    }

    const confirmDeleteItemPopup = async () => {

        if (deleteItemId > 0) {

            const response = await apiGet(
                '/api/upload/DeleteUploadImage/', {
                params: { Id: deleteItemId, userId: userId }
            }
            );
            if (response.data.status) {
                setShowDeleteItemPopup(false);
                if (response.data.content == null) {
                    setImageUploadList([]);
                }
                else {

                    setImageUploadList(response.data.content);
                }
            }
        }
        else {
            if (imageIndex >= 0) {
                if (imageUploadList.length > 1) {
                    const updatedList = imageUploadList.filter((_, index) => index !== imageIndex);
                    setImageUploadList(updatedList);
                }
                else
                {
                    setImageUploadList([]);
                }
            }
            setShowDeleteItemPopup(false);
        }
        
    }

    const handleImageViewPopup = (event, imageName, imageUrl) => {
        setImageViewPopup({ showImageViewPopup: true, imageName: imageName, imageUrl: imageUrl });
    }

    const handleImageViewPopupClose = (event) => {
        setImageViewPopup({ showImageViewPopup: false, imageName: '', imageUrl: '' });
    }

    return (
        <div>
            <Row style={{ marginTop: `15px` }}>
                <Col>
                    <Card>
                        <CardHeader className="card-header-click" onClick={toggle}>
                            <Row>
                                <Col sm="11"><h6>Map</h6></Col>
                                <Col sm="1" className="toggleoutline_lt">{isIconUp ? <FaChevronUp /> : <FaChevronDown />}</Col>
                            </Row>
                        </CardHeader>
                        <Collapse isOpen={isOpen}>
                            <CardBody>
                                <Row>
                                    <Col>
                                        {(roleName == 'Admin' || isAddEditItem == 'true') &&
                                            <>
                                                {!disabledMode && <>
                                                    <Button style={{ float: `right` }} color="success" size="sm" onClick={handleBtnUploadClick} >Upload Map</Button>
                                                    <input style={{ float: `right`, display: 'none' }}
                                                        ref={input => {
                                                            inputFile = input;
                                                        }}
                                                        className="fileInput" id="fileUpload" type="file" onChange={(e) => handleImageChange(e)} /></>
                                                }
                                            </>
                                        }
                                    </Col>
                                </Row>
                                <Row style={{ marginTop: `15px`, marginBottom: `15px` }}>
                                    <Col>
                                        <Card>
                                            <CardBody>
                                                <Table>
                                                    <thead>
                                                        <tr>
                                                            <th>Date</th>
                                                            <th>Name</th>
                                                            <th>View</th>
                                                            <th>Delete</th>
                                                        </tr>
                                                    </thead>
                                                    {imageUploadList != undefined && imageUploadList != null && imageUploadList.length > 0 &&
                                                        <tbody>
                                                            {imageUploadList.map((item, index) => (
                                                                <tr>
                                                                    <td>{item.createdOnText}</td>
                                                                    <td>{item.imageName}</td>
                                                                    <td>
                                                                        <img src={item.imageRelativePath} className="image-popup-thumbnail" alt={item.imageName}
                                                                            onClick={(event, imageName, imageUrl) => handleImageViewPopup(event, item.imageName, item.imageRelativePath)}></img>
                                                                    </td>
                                                                    <td>
                                                                        {(roleName == 'Admin' || isAddEditItem == 'true') &&
                                                                            <>
                                                                            {!disabledMode && <button type="button" id="btnUpdate" className="btn btn-sm btn-danger" onClick={() => openDeleteItemPopup(item, index)}><FaTrash /></button>}
                                                                            </>
                                                                        }
                                                                    </td>
                                                                </tr>
                                                            ))}
                                                        </tbody>
                                                    }
                                                </Table>
                                            </CardBody>
                                        </Card>
                                    </Col>
                                </Row>
                            </CardBody>
                        </Collapse>
                    </Card>
                </Col>
            </Row>

            <Modal isOpen={showUploadingPopup} centered backdrop="static" keyboard={false} contentClassName="custom-upload-modal">
                <ModalBody className="d-flex justify-content-center align-items-center" style={{ minHeight: '100px' }}>
                    <div className="text-center">
                        <div className="spinner-border mb-2" role="status" style={{ color: '#B6D137' }}>
                            <span className="visually-hidden">Loading...</span>
                        </div>
                        <div className="text-center fs-5" style={{ color: '#B6D137' }}>
                            Uploading image...
                        </div>
                    </div>
                </ModalBody>
            </Modal>

            <Modal isOpen={showDeleteItemPopup}>
                <ModalHeader>Delete the item</ModalHeader>
                <ModalBody>
                    Do you want to delete the item ?
                </ModalBody>
                <ModalFooter>
                    <Button color="primary" onClick={confirmDeleteItemPopup}>Yes</Button>
                    <Button color="danger" onClick={closeDeleteItemPopup}>No</Button>
                </ModalFooter>
            </Modal>

            <Modal isOpen={imageViewPopup.showImageViewPopup} size="lg" className="imageViewPopup">
                <ModalHeader toggle={handleImageViewPopupClose} >{imageViewPopup.imageName}</ModalHeader>
                <ModalBody>
                    <img src={imageViewPopup.imageUrl} className="item-image-popup" alt={imageViewPopup.imageName} ></img>
                </ModalBody>
                <ModalFooter>
                    <Button color="danger" onClick={handleImageViewPopupClose}>Close</Button>
                </ModalFooter>
            </Modal>
        </div>
    )
}

export default PhotosWinterGrazingWithoutId